import React from "react"
import {
  Snackbar,
  SnackbarProps,
  Slide,
  SlideProps,
  styled,
} from "@mui/material"

function SlideDown(props: SlideProps) {
  return <Slide {...props} direction="down" />
}

export const SnackbarComponent = styled(
  (props: SnackbarProps & { type: string }) => (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      TransitionComponent={SlideDown}
      {...props}
    >
      {props.children}
    </Snackbar>
  ),
)(({ theme, type }) => ({
  "& .MuiSnackbarContent-root": {
    backgroundColor:
      type === "success"
        ? theme.palette.success.main
        : theme.palette.warning.main,
    borderRadius: "25px",
    boxShadow: "none",
    color: theme.palette.common.white,
    padding: "5px 25px",
    justifyContent: "center",
  },
}))

export default SnackbarComponent
